import { Injectable, EventEmitter } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { FormControl, FormGroup } from "@angular/forms";
import { FileUploadValidators } from "@iplab/ngx-file-upload";
import { TemplateManagementService } from "./template-mgt.service";
import Swiper from "swiper";
import { MockPopulatorService } from "./mock-populator.service";
import { forkJoin, isObservable } from "rxjs";
import {
  ModuleTypes,
  IItem,
  EntryTypes,
  IWelcomePage,
  IBusiness,
  IMultiProperties,
  IItemList,
  PageTypes,
  IConfigPage,
} from "src/app/metadata/interfaces/page/Pages";
import { SnackBarService } from "src/app/services/snack-bar/snack-bar.service";
import { SkyaccessApp } from "src/app/services/skyaccessconfig/skyaccess-app.service";
import { SkyAccess_IFrame } from "src/app/constants/skyaccessconfig/hotel/iframe";

declare const $: any;

@Injectable({
  providedIn: "root",
})
export class UtilityService {
  onInitEmitter = new EventEmitter<any>();

  skyAccessTab;

  // declare const $: any;
  _Index = 0;

  GnSetting: IItem[];
  ModuleList_1: IItem[];
  ModuleList_2: IItem[];

  _Txt: EntryTypes;
  _Color: EntryTypes;
  _BgColor: EntryTypes;
  _SlideSett: EntryTypes;

  _ModuleIdex: number;
  _ItemListIndex: number;
  _AddedTemplates: number;

  WelcomePages: IWelcomePage;
  Businesses: IBusiness;
  ChatsView: IItem[];
  AccDrView: IItem[];

  ConfigPage: IConfigPage;

  ActiveTab: string;

  HotelLink: any;
  GuideLink: any;

  _CurrentHmoduleID: string;
  _CurrentGmoduleID: string;

  Properties: IMultiProperties[];

  isLoadingH: EventEmitter<boolean> = new EventEmitter<boolean>();
  isLoading: boolean;
  lockLoader = { isLocked: false };
  lockLoaderArraySuccessful = [];
  lockLoaderEventEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  apiLoadLockConclusionEmitter: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  handleSummerNoteEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  ModLoadingCount: number = 0;
  _Hash: any;

  BaseUrl: any;
  RestaurantLink: any;
  WelcomeLink: any;
  HotelListLink: any;
  GuideListLink: any;
  ChatLink: any;
  DoorAccessLink: any;

  MHCount: number;
  MGCount: number;
  MHCountEmitter: EventEmitter<number> = new EventEmitter<number>();
  MGCountEmitter: EventEmitter<number> = new EventEmitter<number>();

  isLoadingFromNewTemplate: boolean = false;

  MHCountPublic = 0;
  MGCountPublic = 0;

  navIDs = {
    MmMuliprop: "multi-properties",
    MmHome: "home",
    MmHotel: "hotel",
    MmGuide: "city-guide",
    ShareOnFb: "facebook",
    ShareOnTTr: "twitter",
    ShareOnInst: "instagram",
    HomeScreen: "HomeScreen",
  };

  //IframesDoc = (document.getElementById('myFrame') as HTMLIFrameElement).contentWindow.document;
  /* Toast */

  position = "bottom-right";
  title: string;
  msg: string;
  showClose = true;
  theme = "bootstrap";
  type = "default";
  closeOther = false;

  /*End Toast */

  private filesControl = new FormControl(
    null,
    FileUploadValidators.filesLimit(2)
  );
  VideoForm = new FormGroup({ files: this.filesControl });

  isSkyAccess = false;

  constructor(
    private skyAcceAp: SkyaccessApp,
    private sanitizer: DomSanitizer,
    // private toastyService: ToastyService,
    private templateMgtService: TemplateManagementService,
    public snackbar: SnackBarService,
    private mockPopulator: MockPopulatorService
  ) {
    var handleEvent = (e) => {
      this._Index = e.detail.ActiveID;
      this._ItemListIndex = e.detail.ActiveID;
    };
    window.document.addEventListener("myEvent", handleEvent, false);

    this.MHCount = 0;
    this.MGCount = 0;

    this._Txt = EntryTypes.Txt;
    this._Color = EntryTypes.Color;
    this._BgColor = EntryTypes.BgColor;
    this._SlideSett = EntryTypes.SlideSett;

    this.ActiveTab = "Module1";
    this._ModuleIdex = 0;
    this._ItemListIndex = 0;
    this._AddedTemplates = 0;

    this.initLinks();
  }

  initLinks() {
    // this.HotelLink = this.sanitizer.bypassSecurityTrustResourceUrl("./hotel/hotel-business/business-module-1000");
    // this.GuideLink = this.sanitizer.bypassSecurityTrustResourceUrl("./cityguide/guides/guide-module-1000");

    this._CurrentHmoduleID = "business-module-1000";
    this._CurrentGmoduleID = "guide-module-1000";

    // this.BaseUrl = (location.host == 'http://localhost:8080') ? 'http://localhost:8080' : 'https://www.skyaccess.us/SkyAccessApp';
    // this.BaseUrl = ""; //  'https://www.skyaccess.us/SkyAccessApp';

    let address = window.location.href.toLocaleLowerCase();
    this.BaseUrl = address.includes("skyaccess/hotel")
      ? address.substring(0, address.indexOf("/skyaccess/hotel"))
      : "";

    this.HotelLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.BaseUrl + "/hotel/hotel-business/business-module-1000"
    );
    this.GuideLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.BaseUrl + "/cityguide/guides/guide-module-1000"
    );

    this.RestaurantLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.BaseUrl + "/cityguide/restaurant"
    );
    this.WelcomeLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.BaseUrl + "/hotel/welcome"
    );
    this.HotelListLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.BaseUrl + "/hotel/hotel-business-list"
    );
    this.GuideListLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.BaseUrl + "/cityguide/guide-list"
    );
    this.ChatLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.BaseUrl + "/hotel/chat"
    );
    this.DoorAccessLink = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.BaseUrl + "/hotel/doors-access"
    );
  }

  public updateModuleCounters(isModule1 = true) {
    if (isModule1) {
      this.ModuleList_1.forEach((m) => {
        if (
          m.Enabled &&
          m.ID.startsWith("business-module") &&
          this.GnSetting[2].Enabled
        ) {
          // this.MHCount++;
          this.MHCountPublic++;
        }
      });
    } else {
      this.MGCountPublic = 0;
      this.ModuleList_2.forEach((m) => {
        if (
          m.Enabled &&
          m.ID.startsWith("guide-module") &&
          this.GnSetting[3].Enabled
        ) {
          // this.MHCount++;
          this.MGCountPublic++;
        }
      });
    }
  }

  async OnInit() {
    this.initLinks();
    this.ShowLoading();
    this.lockLoaderEventEmitter.subscribe((state) => {
      if (
        !!this.GnSetting &&
        !!this.ModuleList_1 &&
        !!this.ModuleList_2 &&
        !!this.Businesses
      ) {
        this.lockLoader.isLocked = false;
        this.apiLoadLockConclusionEmitter.emit(true);
        this.HideLoading();
      }
    });

    /* odering must be added in the object */

    this._Hash = this.skyAcceAp.GetHash();

    var handleChecks = (val, field, title) => {
      let response = this.mockPopulator.checkData(val, field, title);
      if (isObservable(response)) {
        response.subscribe((value) => {
          this[field.replace("_", "")] = value;
          emitTrue();
        });
      } else if (response == null) {
        // if(field === "_WelcomePages") return this.parseWelcomePage();
        // else if(field === "_Businesses") return this.parseBusinesses();
        // else this[field.replace("_", "")] = value;
      }
    };

    var emitTrue = () => {
      this.lockLoaderEventEmitter.emit(true);
    };

    var parseWelcomePage = () => {};

    var parseModuleList1 = () => {
      this.MHCountPublic = 0;
      this.ModuleList_1.forEach((m) => {
        if (
          m.Enabled &&
          m.ID.startsWith("business-module") &&
          this.GnSetting[2].Enabled
        ) {
          // this.MHCount++;
          this.MHCountPublic++;
        }
      });
    };

    var parseModuleList2 = () => {
      this.MGCountPublic = 0;
      this.ModuleList_2.forEach((m) => {
        if (
          m.Enabled &&
          m.ID.startsWith("guide-module") &&
          this.GnSetting[3].Enabled
        ) {
          // this.MHCount++;
          this.MGCountPublic++;
        }
      });
    };

    var parseBusinesses = () => {
      // this
    };

    var GnSetting = (val: any): void => {
      this.GnSetting = val;
      this.lockLoaderEventEmitter.emit(true);
    };
    // this.GnSetting = await this.skyAcceAp.GetGeneralSettg().toPromise();
    // (this.GnSetting);
    // .subscribe(GnSetting);

    var ModuleList_1 = (val: any): void => {
      this.ModuleList_1 = val;
      this.ModuleList_1.forEach((m) => {
        if (this.GnSetting == undefined) return;
        if (
          m.Enabled &&
          m.ID.startsWith("business-module") &&
          this.GnSetting[2].Enabled
        ) {
          this.MHCount++;
        }
      });
      this.lockLoaderEventEmitter.emit(true);
    };
    // this.ModuleList_1 = await this.skyAcceAp.GetModule1().toPromise();
    // .subscribe(ModuleList_1);

    var ModuleList_2 = (val: any): void => {
      this.ModuleList_2 = val;
      this.ModuleList_2.forEach((m) => {
        if (this.GnSetting == undefined) return;
        if (
          m.Enabled &&
          m.ID.startsWith("guide-module") &&
          this.GnSetting[3].Enabled
        ) {
          this.MHCount++;
        }
      });
      this.lockLoaderEventEmitter.emit(true);
    };
    // this.ModuleList_2 = await this.skyAcceAp.GetModule2().toPromise();
    // .subscribe(ModuleList_2);

    var WelcomePages = (val: any): void => {
      this.WelcomePages = val;
      this.lockLoaderEventEmitter.emit(true);
    };
    // this.WelcomePages = await this.skyAcceAp.GetWelcomePage().toPromise();
    // .subscribe(WelcomePages);

    var Businesses = (val: any): void => {
      this.Businesses = val;
      this.lockLoaderEventEmitter.emit(true);
    };

    var ConfigPage = (val: any): void => {
      this.ConfigPage = val;
    };
    // await this.skyAcceAp.GetBusinessDetails().subscribe(Businesses);

    this.skyAcceAp.getAllPages().subscribe(async (res) => {
      this.skyAcceAp.setAllPages(res);
      const requests = [
        this.skyAcceAp.GetGeneralSettg(),
        this.skyAcceAp.GetModule1(),
        this.skyAcceAp.GetModule2(),
        this.skyAcceAp.GetWelcomePage(),
        this.skyAcceAp.GetBusinessDetails(),
        this.skyAcceAp.GetConfigSettings(),
      ];
      const responses = await forkJoin(requests).toPromise();

      //console.log(responses)

      //alert("res...");

      GnSetting(responses[0]);
      ModuleList_1(responses[1]);
      ModuleList_2(responses[2]);
      WelcomePages(responses[3]);
      Businesses(responses[4]);
      ConfigPage(responses[5]);
      parseModuleList1();
      parseModuleList2();
      this.onInitEmitter.emit(true);

      var ChatsView = (val: any): void => {
        this.ChatsView = val;
      };
      await this.skyAcceAp.GetChatView(ChatsView);

      var AccDrView = (val: any): void => {
        this.AccDrView = val;
      };
      await this.skyAcceAp.GetAcDrView(AccDrView);

      var Properties = (val: any): void => {
        this.Properties = val;
      };
      await this.skyAcceAp.GetProperties(Properties);

      this.HideLoading();
    });
  }

  async AfterViewInit() {
    this.HideLoading();
  }

  onSaveBusinessInfo() {
    this.MHCountEmitter.emit(this.getMHCount());
    this.MGCountEmitter.emit(this.getMGCount());
  }

  getMHCount() {
    let MHCountTemp = 0;
    this.ModuleList_1.forEach((m) => {
      if (
        m.Enabled &&
        m.ID.startsWith("business-module") &&
        this.GnSetting[2].Enabled
      )
        MHCountTemp++;
    });
    this.MHCount = MHCountTemp;

    return this.MHCount;
  }

  getMGCount() {
    let MGCountTemp = 0;
    this.ModuleList_2.forEach((m) => {
      if (
        m.Enabled &&
        m.ID.startsWith("guide-module") &&
        this.GnSetting[3].Enabled
      )
        MGCountTemp++;
    });
    this.MGCount = MGCountTemp;
    return this.MGCount;
  }

  AddToast(
    title: string,
    msg: string,
    type: string,
    closeOther: boolean = false
  ) {}

  //#region buttons actions

  HideLoading() {
    setTimeout(() => {
      // if (!this.lockLoader.isLocked) {
      if (true) {
        this.isLoading = false;
        this.isLoadingH.emit(false);
      }
    }, 50);
  }

  ShowLoading() {
    this.isLoading = true;
    this.isLoadingH.emit(true);
  }

  DisplayStatusMsg(data: any): void {
    if (data == true) {
      this.AddToast(
        "Successfully saved !",
        "The settings have been properly saved",
        "success"
      );
    } else
      this.AddToast(
        "Failed !",
        "The settings Can't be save for the moment, unexpected eoor",
        "error"
      );
  }

  ReLoadFrame(id = "myFrame"): void {
    id;
    setTimeout(() => {
      let IframesDoc = (document.getElementById(id) as HTMLIFrameElement)
        .contentWindow.document;
      IframesDoc.location.reload();
    });
  }

  SlideToIndex(index: number, frameID = "myFrame") {
    setTimeout(() => {
      if (this._AddedTemplates != 0) {
        index = this._AddedTemplates;
        this._AddedTemplates = 0;
      }
      let eventEmitter = function SlideChanged(eventId) {
        let myCustomData = { ActiveID: eventId };
        let ev = new CustomEvent("myEvent", { detail: myCustomData });

        window.parent.document.dispatchEvent(ev);
      };

      let intervalCounter = 0;

      let myInterval = setInterval(() => {
        let mySwipe = (
          document.getElementById(frameID) as HTMLIFrameElement
        ).contentWindow.document.querySelector(".swiper-container-h") as any;
        intervalCounter++;

        if (intervalCounter > 30) clearInterval(myInterval);
        if (mySwipe == null) return;
        let thisSwiper: Swiper = (mySwipe as any).swiper;
        if (thisSwiper == undefined) return;

        if (index === -1) {
          thisSwiper.slideTo(thisSwiper.slides.length - 1);
        } else {
          thisSwiper.slideTo(index);
        }

        clearInterval(myInterval);
      }, 200);
    }, 500);
  }

  SlideToIndexWelcome(index: number, frameID = SkyAccess_IFrame.WELCOME_PAGE) {
    setTimeout(() => {
      try {
        let IframesDoc = (document.getElementById(frameID) as HTMLIFrameElement)
          .contentWindow.document;
        let Swp: any = IframesDoc.querySelector(".swiper-container");
        // (Swp);
        if (Swp == undefined || Swp == null) return;

        var mySwiper = Swp.swiper;
        mySwiper.update();
        mySwiper.slideTo(index);
      } catch (error) {}
      this.HideLoading();
    }, 100);
  }

  //#endregion

  isModule(ID: string): boolean {
    if (ID.startsWith("business-module")) return true;
    else return false;
  }

  isModuleOrOther(ID: string): boolean {
    if (ID.startsWith("business-module") || ID.startsWith("guide-module"))
      return true;
    else return false;
  }

  OnEffectChange(IsHotelModule: boolean, value: any) {
    this.AddToast(
      "Save the changes to visualize the effect !",
      "The animation settings are applied accross the application.",
      "warning"
    );
  }

  HideToolbar() {
    (
      document.querySelector(
        ".noteModal .note-btn-group.note-view"
      ) as HTMLElement
    ).style.display = "none";
    (
      document.querySelector(
        ".noteModal .note-btn-group.note-insert"
      ) as HTMLElement
    ).style.display = "none";
    (
      document.querySelector(
        ".noteModal .note-btn-group.note-table"
      ) as HTMLElement
    ).style.display = "none";
    (
      document.querySelector(
        ".noteModal .note-btn-group.note-para"
      ) as HTMLElement
    ).style.display = "none";
    (
      document.querySelector(
        ".noteModal .note-btn-group.note-color"
      ) as HTMLElement
    ).style.display = "none";
    (
      document.querySelector(
        ".noteModal .note-btn.note-btn-underline"
      ) as HTMLElement
    ).style.display = "none";
  }

  HideSummerToolBar(Item: string, ID: string) {
    switch (Item) {
      case "TabGn":
        this.HideToolbar();
        break;

      case "TabBsg_H":
        this.HideToolbar();
        break;

      case "TabBsg_G":
        this.HideToolbar();
        break;

      case "TabWpg_H":
        this.HideToolbar();
        break;

      case "TabWpg_G":
        this.HideToolbar();
        break;

      case "TabBls_H":
        break;

      case "TabBls_G":
        break;

      case "TabBds_H":
        if (ID == "Img2" || ID == "Descp" || ID == "Descp2") {
          break;
        } else {
          this.HideToolbar();
          break;
        }

      case "TabBds_G":
        if (ID != "Img") this.HideToolbar();
        break;

      case "TabCs":
        break;

      case "TabAdr":
        break;
    }
  }

  TabChangedGenral(Tab, pageHasInitialized) {
    // this.ShowLoading();

    this._ModuleIdex = 0;
    this._ItemListIndex = 0;
    this._Index = 0;

    // this.ActiveTab = 'Module1';

    // let myVar = "TabBds";

    switch (Tab.nextId) {
      case "TabGn":
        pageHasInitialized.generalSettings = true;
        break;

      case "TabBsg":
        pageHasInitialized.businessSettings = true;
        break;

      case "TabWpg":
        pageHasInitialized.welcomePage = true;
        break;

      case "TabBls":
        pageHasInitialized.businessLists = true;
        this.ActiveTab = "blModule1";
        break;

      case "TabBds":
        pageHasInitialized.businessDetails = true;
        this.HandleSummerNote(".noteV .note-editable", 1);
        this.ActiveTab = "Module1";
        break;

      case "TabCs":
        break;

      case "TabAdr":
        break;
    }
  }

  TabChangedWelcome(tb) {
    switch (tb.activeId) {
      case "TabWelM1":
        this.SlideToIndexWelcome(0);
        break;

      case "TabWelM2":
        this.SlideToIndexWelcome(1);
        break;
    }
  }

  TabChanged(tb) {
    /* reset the indexes when the tab switch */
    this._ItemListIndex = 0;
    this._ModuleIdex = 0;
    this._Index = 0;
    this.ShowLoading();

    switch (tb.activeId) {
      case "Module1":
        this.ActiveTab = "Module1";
        this.HandleSummerNote(".noteV .note-editable", 1);
        break;

      case "Module2":
        this.ActiveTab = "Module2";
        this.HandleSummerNote(".noteV .note-editable", 2);
        break;
    }

    this.HideLoading();
  }

  TabChangedBusinessList(tb, init = true) {
    this.ShowLoading();

    switch (tb.activeId) {
      case "blModule1":
        this.ActiveTab = "blModule1";
        if (init) this.HandleSummerNote(".noteV .note-editable", 1);
        break;
      case "blModule2":
        this.ActiveTab = "blModule2";
        if (init) this.HandleSummerNote(".noteV .note-editable", 2);
        break;
    }
    this.HideLoading();
  }

  OnModuleChange(IsHotelModule: boolean, value: any): number {
    this._ItemListIndex = 0;
    this._Index = 0;
    this.ShowLoading();

    if (IsHotelModule) {
      this._ModuleIdex = this.ModuleList_1.findIndex((s) => s.VarTxt == value);
      let M = this.ModuleList_1.filter((s) => s.VarTxt == value);
      this._CurrentHmoduleID = M[0].ID;

      let tmp = this.Businesses.Hotel.filter(
        (s) => s.ItemModule.ID == this._CurrentHmoduleID
      );
      /* Since all the module are available, just get it without any check */
      if (tmp[0].Itemlist.length == undefined || tmp[0].Itemlist.length == 0) {
        this.NewItemsOnModule(IsHotelModule, this._CurrentHmoduleID);
        /* save the business on the local storage */
      }
      this.HotelLink = this.sanitizer.bypassSecurityTrustResourceUrl(
        "./hotel/hotel-business/" + this._CurrentHmoduleID
      );
    } else {
      this._ModuleIdex = this.ModuleList_2.findIndex((s) => s.VarTxt == value);
      let M2 = this.ModuleList_2.filter((ss) => ss.VarTxt == value);
      this._CurrentGmoduleID = M2[0].ID;

      let tmp = this.Businesses.CityGuide.filter(
        (s2) => s2.ItemModule.ID == this._CurrentGmoduleID
      );

      if (tmp[0].Itemlist.length == undefined || tmp[0].Itemlist.length == 0) {
        this.NewItemsOnModule(IsHotelModule, this._CurrentGmoduleID);
        /* save the business on the local storage */
      }

      this.GuideLink = this.sanitizer.bypassSecurityTrustResourceUrl(
        "./cityguide/guides/" + this._CurrentGmoduleID
      );
    }

    return this._ModuleIdex;
  }

  OnIframeClick(): void {
    this._ItemListIndex = this._Index;
  }

  GetHotelModuleType(index: number): ModuleTypes {
    switch (index) {
      case 0:
        return ModuleTypes.IsModuleHotel1;
        break;

      case 1:
        return ModuleTypes.IsModuleHotel2;
        break;

      case 2:
        return ModuleTypes.IsModuleHotel3;
        break;

      case 3:
        return ModuleTypes.IsModuleHotel4;
        break;

      case 4:
        return ModuleTypes.IsModuleHotel5;
        break;

      case 5:
        return ModuleTypes.IsModuleHotel6;
        break;

      case 6:
        return ModuleTypes.IsModuleHotel7;
        break;

      default:
        return ModuleTypes.IsModuleHotel1;
    }
  }

  GetGuideModuleType(index: number): ModuleTypes {
    switch (index) {
      case 0:
        return ModuleTypes.IsModuleGuide1;
        break;

      case 1:
        return ModuleTypes.IsModuleGuide2;
        break;

      case 2:
        return ModuleTypes.IsModuleGuide3;
        break;

      case 3:
        return ModuleTypes.IsModuleGuide4;
        break;

      case 4:
        return ModuleTypes.IsModuleGuide5;
        break;

      case 5:
        return ModuleTypes.IsModuleGuide6;
        break;

      case 6:
        return ModuleTypes.IsModuleGuide7;
        break;

      default:
        return ModuleTypes.IsModuleGuide1;
    }
  }

  SetQueryStyle(Class: string, Tag: string, val: any, frameID = "myFrame") {
    let IframesDoc = (document.getElementById(frameID) as HTMLIFrameElement)
      .contentWindow.document;
    let Elm = IframesDoc.querySelector(Class) as HTMLElement;

    if (Elm == undefined || Elm == null) return -1;

    switch (Tag) {
      case "color":
        Elm.style.color = val;
        break;

      case "background":
        Elm.style.background = val;
        break;

      case "display":
        Elm.style.display = val;
        break;

      case "borderColor":
        Elm.style.borderColor = val;
        break;

      case "innerText":
        Elm.innerText = val;
        break;

      case "innerHTML":
        Elm.innerHTML = val;
        break;
    }
  }

  toggleStatus() {
    this.filesControl.disabled
      ? this.filesControl.enable()
      : this.filesControl.disable();
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  HandleSummerNoteCB(moduleID: number) {
    let ID: string = "";
    let Htmlinn: string = $(".summernote").summernote("code");

    switch (moduleID) {
      case 1:
        ID =
          this.Businesses.Hotel[this._ModuleIdex].Itemlist[this._ItemListIndex]
            .Items[4].ID;
        this.Businesses.Hotel[this._ModuleIdex].Itemlist[
          this._ItemListIndex
        ].Items[4].VarTxt = Htmlinn;
        break;

      case 2:
        ID =
          this.Businesses.CityGuide[this._ModuleIdex].Itemlist[
            this._ItemListIndex
          ].Items[5].ID;
        this.Businesses.CityGuide[this._ModuleIdex].Itemlist[
          this._ItemListIndex
        ].Items[5].VarTxt = Htmlinn;
        break;
    }

    this.SetBusDetails(ID, "txt", Htmlinn);
  }

  HandleSummerNote(classes: string, moduleID: number) {}

  AddNewTemplate(): void {
    let IsHotelModule: boolean = this.ActiveTab == "Module1" ? true : false;

    if (IsHotelModule) {
      this.NewItemsOnModule(IsHotelModule, this._CurrentHmoduleID).subscribe(
        (value) => {
          let newModule = value;

          let result = newModule.res.Response.Result;
          let tempItems = newModule.items;
          let totalItems = newModule.totalItems;
          let moduleIndex = newModule.moduleIndex;
          tempItems.Items.forEach((item) => {
            result.forEach((element) => {
              if (element._ID == item.ID) {
                item.SkyAccessDesignID = element._SkyAccessDesignID;
              }
            });
          });
          this.Businesses.Hotel[moduleIndex].Itemlist.push(tempItems);
          this._AddedTemplates = totalItems;
          this.HotelLink = this.sanitizer.bypassSecurityTrustResourceUrl(
            "./hotel/hotel-business/" + this._CurrentHmoduleID
          );

          this.ReLoadFrame();
          // let ModuleIndex = this.Businesses.Hotel.findIndex(s => s.ItemModule.ID == this._CurrentHmoduleID);
          // this.SlideToIndex(-1);
          this.handleSummerNoteEvent.emit(false);
          this.HideLoading();
          this.snackbar.showSnackBar("Template Added Successfully!");
        }
      );
    } else {
      this.NewItemsOnModule(IsHotelModule, this._CurrentGmoduleID).subscribe(
        (value) => {
          let newModule = value;

          let result = newModule.res.Response.Result;
          let tempItems = newModule.items;
          let totalItems = newModule.totalItems;
          let moduleIndex = newModule.moduleIndex;
          tempItems.Items.forEach((item) => {
            result.forEach((element) => {
              if (element._ID == item.ID) {
                item.SkyAccessDesignID = element._SkyAccessDesignID;
              }
            });
          });
          this.Businesses.CityGuide[moduleIndex].Itemlist.push(tempItems);
          this._AddedTemplates = totalItems;
          this.GuideLink = this.sanitizer.bypassSecurityTrustResourceUrl(
            "./cityguide/guides/" + this._CurrentGmoduleID
          );

          this.ReLoadFrame();
          // let ModuleIndex = this.Businesses.CityGuide.findIndex(s => s.ItemModule.ID == this._CurrentHmoduleID);
          // this.SlideToIndex(-1);
          this.handleSummerNoteEvent.emit(false);
          this.HideLoading();
          this.snackbar.showSnackBar("Template Added Successfully!");
        }
      );
    }
  }

  DeleteTemplate(): void {
    // let IframesDoc = (document.getElementById('myFrame') as HTMLIFrameElement).contentWindow.document;
    let IsHotelModule: boolean = this.ActiveTab == "Module1" ? true : false;
    if (IsHotelModule) {
      let tmp = this.Businesses.Hotel.filter(
        (s) => s.ItemModule.ID == this._CurrentHmoduleID
      );
      if (tmp[0].Itemlist.length <= 1) {
        /*Display message - The last template of each module can't be deleted */

        this.AddToast(
          "Deleting impossible!",
          "The last template of each module can't be deleted",
          "warning"
        );
      } else {
        this.RemoveItemsOnModule(
          IsHotelModule,
          this._CurrentHmoduleID,
          this._ItemListIndex
        ).subscribe((value) => {
          let ModuleIndex = this.Businesses.Hotel.findIndex(
            (s) => s.ItemModule.ID == this._CurrentHmoduleID
          );

          if (this._ItemListIndex >= 1) this._ItemListIndex--;

          this.AddToast(
            "Successfully done!",
            "The selected Template has been removed ",
            "success"
          );

          this.HotelLink = this.sanitizer.bypassSecurityTrustResourceUrl(
            "./hotel/hotel-business/" + this._CurrentHmoduleID
          );
          this.handleSummerNoteEvent.emit(true);
          this.HideLoading();
          this.snackbar.showSnackBar("Template Deleted Successfully!");
        });

        /* save and reload the iframe */
        // reset this is it is the same module and the iframe are refreched to reload the main page with the new data
        //this._ItemListIndex = 0;

        //IframesDoc.location.reload();
      }
    } else {
      let tmp = this.Businesses.CityGuide.filter(
        (s) => s.ItemModule.ID == this._CurrentGmoduleID
      );
      if (tmp[0].Itemlist.length <= 1) {
        /*Display message - The last template of each module can't be deleted */

        this.AddToast(
          "Deleting impossible !",
          "The last template of each module can't be deleted",
          "warning"
        );
      } else {
        this.RemoveItemsOnModule(
          IsHotelModule,
          this._CurrentGmoduleID,
          this._ItemListIndex
        ).subscribe((value) => {
          if (this._ItemListIndex >= 1) this._ItemListIndex--;

          /* save and reload the iframe */
          // reset this is it is the same module and the iframe are refreched to reload the main page with the new data
          //this._ItemListIndex = 0;

          this.AddToast(
            "Successfully done!",
            "The selected Template has been removed ",
            "success"
          );
          this.GuideLink = this.sanitizer.bypassSecurityTrustResourceUrl(
            "./cityguide/guides/" + this._CurrentGmoduleID
          );
          let ModuleIndex = this.Businesses.CityGuide.findIndex(
            (s) => s.ItemModule.ID == this._CurrentHmoduleID
          );
          this.handleSummerNoteEvent.emit(true);
          this.HideLoading();
          this.snackbar.showSnackBar("Template Deleted Successfully!");
        });

        //IframesDoc.location.reload();
      }

      /* After the template deletion, allow to slide to the previous template */
    }
  }

  NewItemsOnModule(IsHotelModule: boolean, ModuleID: string) {
    // this._Hash.s = 286331154; // This should only be used for tests in development environment;
    this._Hash.s = 286331157; // This should only be used for tests in development environment;

    let TotalItems: number = 0;

    if (IsHotelModule) {
      let ModuleIndex = this.Businesses.Hotel.findIndex(
        (s) => s.ItemModule.ID == ModuleID
      );

      if (ModuleIndex != -1) {
        TotalItems = this.Businesses.Hotel[ModuleIndex].Itemlist.length;
        let newData = this.templateMgtService.handleManagement(
          IsHotelModule,
          ModuleID,
          this.Businesses
        );
        let Ord =
          this.Businesses.Hotel[ModuleIndex].Itemlist[TotalItems - 1].Items[0]
            ._Ord + 1;
        let TemItems: IItemList = {
          Items: [
            {
              _SysNumber: this._Hash.s,
              Enabled: true,
              _Ord: Ord,
              ID: "Title",
              StaticTxt: "Title:",
              VarTxt: newData.title,
              Color: "#ffffff",
              BgColor: "rgb(0,0,0,0.5)",
              EntryType: EntryTypes.ALL,
              ModuleType: this.GetHotelModuleType(ModuleIndex),
              PageType: PageTypes.SA_BusinessesView,
            },
            {
              _SysNumber: this._Hash.s,
              Enabled: true,
              _Ord: Ord,
              ID: "Img",
              StaticTxt: "Image:",
              Links: newData.imgLink,
              VarTxt: "",
              EntryType: EntryTypes.Txt,
              ModuleType: this.GetHotelModuleType(ModuleIndex),
              PageType: PageTypes.SA_BusinessesView,
            },
            {
              _SysNumber: this._Hash.s,
              Enabled: true,
              _Ord: Ord,
              ID: "BtTxt",
              StaticTxt: "Button text:",
              VarTxt: newData.buttonText,
              Color: "#ffffff",
              EntryType: EntryTypes.Txt,
              ModuleType: this.GetHotelModuleType(ModuleIndex),
              PageType: PageTypes.SA_BusinessesView,
            },
            {
              _SysNumber: this._Hash.s,
              Enabled: true,
              _Ord: Ord,
              ID: "ExterLink",
              StaticTxt: "Set button link:",
              Links: "http://www.amadeosystems.com",
              EntryType: EntryTypes.Txt,
              ModuleType: this.GetHotelModuleType(ModuleIndex),
              PageType: PageTypes.SA_BusinessesView,
            },
            {
              _SysNumber: this._Hash.s,
              Enabled: true,
              _Ord: Ord,
              ID: "Descp",
              StaticTxt: "Details:",
              VarTxt:
                "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>",
              Color: "#ffffff",
              EntryType: EntryTypes.Txt,
              ModuleType: this.GetHotelModuleType(ModuleIndex),
              PageType: PageTypes.SA_BusinessesView,
            },
          ],
        };
        /* add these items to the database */
        return this.skyAcceAp
          .createBusinessDetailsTemplate(TemItems.Items)
          .map((res: any) => {
            TotalItems++;

            this.SaveBusinessDetailChanges();
            return {
              items: TemItems,
              totalItems: TotalItems,
              moduleIndex: ModuleIndex,
              res: res,
            };
          });
      }
    } else {
      let ModuleIndex = this.Businesses.CityGuide.findIndex(
        (s2) => s2.ItemModule.ID == ModuleID
      );
      if (ModuleIndex != -1) {
        TotalItems = this.Businesses.CityGuide[ModuleIndex].Itemlist.length;
        let newData = this.templateMgtService.handleManagement(
          IsHotelModule,
          ModuleID,
          this.Businesses
        );
        let Ord =
          this.Businesses.CityGuide[ModuleIndex].Itemlist[TotalItems - 1]
            .Items[0]._Ord + 1;
        let TemItems: IItemList = {
          Items: [
            {
              _SysNumber: this._Hash.s,
              Enabled: true,
              _Ord: Ord,
              ID: "Geo",
              StaticTxt: "Guide Location:",
              Longitude: "0",
              Latitude: "0",
              EntryType: EntryTypes.Geo,
              ModuleType: this.GetGuideModuleType(ModuleIndex),
              PageType: PageTypes.SA_BusinessesView,
            },
            {
              _SysNumber: this._Hash.s,
              Enabled: true,
              _Ord: Ord,
              ID: "Title2",
              StaticTxt: "Title:",
              VarTxt: newData.title,
              Color: "#ffffff",
              BgColor: "rgb(0,0,0,0.5)",
              EntryType: EntryTypes.ALL,
              ModuleType: this.GetGuideModuleType(ModuleIndex),
              PageType: PageTypes.SA_BusinessesView,
            },
            {
              _SysNumber: this._Hash.s,
              Enabled: true,
              _Ord: Ord,
              ID: "Img2",
              StaticTxt: "Image:",
              Links: newData.imgLink,
              VarTxt: "",
              EntryType: EntryTypes.Txt,
              ModuleType: this.GetGuideModuleType(ModuleIndex),
              PageType: PageTypes.SA_BusinessesView,
            },
            {
              _SysNumber: this._Hash.s,
              Enabled: true,
              _Ord: Ord,
              ID: "BtTxt2",
              StaticTxt: "Button text:",
              VarTxt: newData.buttonText,
              Color: "#ffffff",
              EntryType: EntryTypes.Txt,
              ModuleType: this.GetGuideModuleType(ModuleIndex),
              PageType: PageTypes.SA_BusinessesView,
            },
            {
              _SysNumber: this._Hash.s,
              Enabled: true,
              _Ord: Ord,
              ID: "ExterLink2",
              StaticTxt: "Set button link:",
              Links: "http://www.amadeosystems.com",
              EntryType: EntryTypes.Txt,
              ModuleType: this.GetGuideModuleType(ModuleIndex),
              PageType: PageTypes.SA_BusinessesView,
            },
            {
              _SysNumber: this._Hash.s,
              Enabled: true,
              _Ord: Ord,
              ID: "Descp2",
              StaticTxt: "Details:",
              VarTxt:
                "<p>Add some formatted description here if you want the vertical template to be displayed, or delete it if you don't need the template</p>",
              Color: "#ffffff",
              EntryType: EntryTypes.Txt,
              ModuleType: this.GetGuideModuleType(ModuleIndex),
              PageType: PageTypes.SA_BusinessesView,
            },
          ],
        };
        /* add these items to the database */
        return this.skyAcceAp
          .createBusinessDetailsTemplate(TemItems.Items)
          .map((res: any) => {
            let value = res.Response.Result;
            TemItems.Items.forEach((item) => {
              value.forEach((element) => {
                if (element.ID == item.ID) {
                  item.SkyAccessDesignID = element.SkyAccessDesignID;
                }
              });
            });
            this.Businesses.CityGuide[ModuleIndex].Itemlist.push(TemItems);
            TotalItems++;
            //1* (value)

            this.SaveBusinessDetailChanges();
            return {
              items: TemItems,
              totalItems: TotalItems,
              moduleIndex: ModuleIndex,
              res: res,
            };
          });
      }
    }

    //window.localStorage.setItem("BusDtl",  JSON.stringify(this.Businesses));
    // return TotalItems;
  }

  RemoveItemsOnModule(
    IsHotelModule: boolean,
    ModuleID: string,
    ItemlistIndex: number
  ) {
    if (IsHotelModule) {
      let ModuleIndex = this.Businesses.Hotel.findIndex(
        (s) => s.ItemModule.ID == ModuleID
      );
      if (ModuleIndex != -1) {
        let Itemss: IItemList[] = this.Businesses.Hotel[
          ModuleIndex
        ].Itemlist.splice(ItemlistIndex, 1);

        if (Itemss[0].Items != undefined) {
          /* if not inserted in the db, return */

          if (
            Itemss[0].Items[0].SkyAccessDesignID == 0 ||
            Itemss[0].Items[0].SkyAccessDesignID == undefined
          ) {
            /* Do Nothing */
          }
          // return;
          else {
            return this.skyAcceAp
              .deleteBusinessDetailsTemplate(Itemss[0].Items)
              .map((value) => {
                this.ReLoadFrame();
                return value;
              });
          }

          // return;
          // this.skyAcceAp.SK_DeleteItems(Itemss[0].Items).subscribe((Temp) => {
          //   this.DisplayStatusMsg(Temp);
          // },
          //   (err) => (err));
        }
      }
    } else {
      let ModuleIndex = this.Businesses.CityGuide.findIndex(
        (s) => s.ItemModule.ID == ModuleID
      );
      if (ModuleIndex != -1) {
        let Itemss = this.Businesses.CityGuide[ModuleIndex].Itemlist.splice(
          ItemlistIndex,
          1
        );

        return this.skyAcceAp
          .deleteBusinessDetailsTemplate(Itemss[0].Items)
          .map((value) => {
            this.ReLoadFrame();
            this.SlideToIndex(
              this.Businesses.CityGuide[ModuleIndex].Itemlist.length
            );
            return value;
          });
      }
    }

    //window.localStorage.setItem("BusDtl5",  JSON.stringify(this.Businesses));
    this.SaveBusinessDetailChanges();
  }

  SaveBusinessDetailChanges(): IItem[] {
    this.ShowLoading();

    let Items: IItem[] = [];

    // this.Businesses.Hotel.forEach(w => { Items.push(w.ItemModule); });
    // this.Businesses.CityGuide.forEach(w => { Items.push(w.ItemModule); });

    // this.Businesses.Hotel.forEach(w => { w.Itemlist.forEach(i => { i.Items.forEach(a => { Items.push(a); }); }); });
    // this.Businesses.CityGuide.forEach(w => { w.Itemlist.forEach(i => { i.Items.forEach(a => { Items.push(a); }); }); });

    // this.skyAcceAp.SaveBusinessDetails(Items, null);
    // //this.AddToast("Successfully saved !", "The settings have been properly saved", "success");
    // //this.ReLoadFrame();
    // //return;

    return Items;
  }

  SetBusDetails(Id: string, Typ: string, val: any): void {
    var ctClassChecker = (callback, Class, Tag, val) => {
      let tmp = ".CT1-" + this._ModuleIdex + "-" + this._Index;
      if (callback(Class, Tag, val) == -1) {
        callback(tmp, Tag, val);
      }
    };

    var btClassChecker = (callback, Class, Tag, val) => {
      let tmp = ".Bt1-" + this._ModuleIdex + "-" + this._Index;
      if (callback(Class, Tag, val) == -1) {
        callback(tmp, Tag, val);
      }
    };

    switch (Id) {
      case "Title":
      case "Title2":
        if (Typ == "Color")
          ctClassChecker(
            this.SetQueryStyle,
            ".CT-" + this._Index,
            "color",
            val
          );
        else if (Typ == "BgColor")
          ctClassChecker(
            this.SetQueryStyle,
            ".CT-" + this._Index,
            "background",
            val
          );
        else
          ctClassChecker(
            this.SetQueryStyle,
            ".CT-" + this._Index,
            "innerHTML",
            val
          );
        break;

      case "BtTxt":
      case "BtTxt2":
        if (Typ == "Color")
          btClassChecker(
            this.SetQueryStyle,
            ".Bt-" + this._Index,
            "color",
            val
          );
        else if (Typ == "BgColor") {
          btClassChecker(
            this.SetQueryStyle,
            ".Bt-" + this._Index,
            "borderColor",
            val
          );
          btClassChecker(
            this.SetQueryStyle,
            ".Bt-" + this._Index,
            "color",
            val
          );

          btClassChecker(
            this.SetQueryStyle,
            ".Bt-1" + this._Index,
            "borderColor",
            val
          );
          btClassChecker(
            this.SetQueryStyle,
            ".Bt-1" + this._Index,
            "color",
            val
          );
        } else
          btClassChecker(
            this.SetQueryStyle,
            ".Bt-" + this._Index,
            "innerHTML",
            val
          );

        break;

      case "Descp":
      case "Descp2":
        this.SetQueryStyle(".InnerH-" + this._Index, "innerHTML", val);
        if (val != undefined && val.length >= 15)
          this.SetQueryStyle(".Bt-1" + this._Index, "display", "block");
        else this.SetQueryStyle(".Bt-1" + this._Index, "display", "none");

        break;

      case "ExterLink":
      case "ExterLink2":
        if (val != undefined && val.length >= 15)
          this.SetQueryStyle(".Bt-" + this._Index, "display", "initial");
        else this.SetQueryStyle(".Bt-" + this._Index, "display", "none");
        break;
    }
  }
}
